/**
 * Lightweight per-page SEO updater (no react-helmet dep needed).
 * Usage: <Seo title="..." description="..." path="/services" />
 *
 * Updates: <title>, meta[description], canonical, og:title, og:description, og:url, twitter:title.
 */
import { useEffect } from "react";

const SITE = "https://chakritravels.com";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullUrl = `${SITE}${path}`;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", fullUrl);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(fullUrl);
  }, [title, description, path]);

  return null;
};

export default Seo;
